import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../checkbox/Checkbox';
import '../../checkbox-select/CheckboxSelect.scss';


const FilterOption = ({value, onClick, isChecked, children, dataQa}) => {
    return (
        <label
            className="ace-c-checkbox-select__option"
            onClick={() => onClick(value)}
            data-qa={dataQa || `filter-option-${value}`}
        >
            <Checkbox isIconSmall isChecked={isChecked} dataQa={`checkbox-${dataQa || `filter-option-${value}`}`} />
            <span className="ace-c-checkbox-select__option-text">{children}</span>
        </label>
    );
};

FilterOption.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
    isChecked: PropTypes.bool.isRequired,
    dataQa: PropTypes.string,
};

FilterOption.defaultProps = {
    value: '',
    onClick: () => {},
    dataQa: '',
};

export default FilterOption;
